import React, {useEffect, useState} from 'react';
import {Box, Button, Stack, Text} from '@chakra-ui/react';
import News from './Podcasts/news';
import All from './Podcasts/all';
import {useNavigate, useParams, useLocation, useSearchParams} from "react-router-dom";
import axios from "axios";
import Container from "../../../components/Container";

const Podcasts = ({podcastsRef}) => {
    const [, setIsLoading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const {pageCount} = useParams();
    const selectedTab = searchParams.get('tab');
    const [startIndex, setStartIndex] = useState(pageCount || 0)
    const [podcastCount, setPodcastCount] = useState(0)
    const [hasNewsData, setHasNewsData] = useState(false)
    const [podcastType, setPodcastType] = useState(selectedTab || 'all')
    const [, setPodcastData] = useState(undefined)
    const [allData, setAllData] = useState(undefined)
    const [showPodcastsButton, setShowPodcastsButton] = useState(false)
    const [showPerspectivesButton, setShowPerspectivesButton] = useState(false)
    const navigate = useNavigate();
    const {slug} = useParams();

    const scrollToPodcasts = () => {
        setTimeout(function() {
            const filters = document.getElementById("podcasts-perspectives");
            // console.log('filters', filters)
            window.scrollTo({
                top: filters.offsetTop - 20,
                behavior: "smooth"
            });
        }, 250);
    };

    useEffect(() => {
        const abortController = new AbortController();
        const fetchAllPodcastData = async () => {
            const allData = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=yes&author_slug=${slug}`, {signal: abortController.signal}).then(resp => {
                return resp.data.items;
            });
            const podcastData = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=only&author_slug=${slug}`, {signal: abortController.signal}).then(resp => {
                return resp.data.items;
            });
            const perspecivesData = await axios.get(`/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=no&author_slug=${slug}`, {signal: abortController.signal}).then(resp => {
                return resp.data.items;
            });
            setShowPodcastsButton(podcastData?.length > 0);
            setShowPerspectivesButton(perspecivesData?.length > 0);
            setAllData(allData)
        }
        fetchAllPodcastData()
        return () => {
            abortController.abort();
        }
    }, [slug, startIndex])

    useEffect(() => {
        const abortController = new AbortController();
        const endpoints = {
            all: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=yes&author_slug=${slug}`,
            podcast: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=only&author_slug=${slug}`,
            perspectives: `/wp-admin/admin-ajax.php?action=get_insights&insights_start=0&insights_include_podcasts=no&author_slug=${slug}`
        }
        const fetchPodcastData = async () => {
            setIsLoading(true)
            const response = await axios.get(endpoints[podcastType], {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            // console.log('fetching podcasts', response)
            setPodcastData(response?.items || [])
            setPodcastCount(response?.total || 0)
            setIsLoading(false)
        }
        fetchPodcastData()
        return () => {
            abortController.abort();
        }
    }, [slug, podcastType, selectedTab])

    useEffect(() => {
        if(selectedTab) {
            scrollToPodcasts();
        }
    }, [selectedTab]);


    return (
        <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section">
            <Box px={['2.5', '5']}>
                <Container>
                    {allData?.length > 0 &&
                        <Text
                            pb={'40px'}
                            as={'h1'}
                            lineHeight={'2rem'}
                            textAlign={'left'}
                            fontSize={'2rem'}
                        >
                            Latest
                        </Text>
                    }
                    <Box textAlign={'left'}>
                        <Box pb={'120px'}>
                            <Stack
                                spacing="16"
                                height={'100%'}
                                alignSelf={'stretch'}
                                direction={{base: 'column', md: 'row'}}
                            >
                                {allData?.length > 0 &&
                                    <>
                                        <Box id={'podcasts-perspectives'} alignSelf={'stretch'} width="full" height={'100%'} ref={podcastsRef} maxWidth={{base: '100%', md:'calc(100% - 250px)'}}>
                                            <Text
                                                borderRight={{
                                                    base: 'none',
                                                    md: hasNewsData ? '1px solid #A1B6E5' : 'none'
                                                }}
                                                pb={'40px'}
                                                as={'h2'}
                                                lineHeight={'18px'}
                                                textAlign={'left'}
                                                fontSize={'lg'}
                                            >
                                                Podcast & Perspectives
                                            </Text>
                                            <Box borderRight={{
                                                base: 'none',
                                                md: hasNewsData ? '1px solid #A1B6E5' : 'none'
                                            }} pb={'50px'}>
                                                <Button isActive={(selectedTab == 'all' || podcastType === 'all')}
                                                        onClick={() => {
                                                            setStartIndex(0)
                                                            navigate(`/teammember/${slug}?tab=all`)
                                                            setPodcastType('all')
                                                        }}>All</Button>
                                                {showPodcastsButton &&
                                                    <Button isActive={(selectedTab == 'podcast' || podcastType === 'podcast')}
                                                            onClick={() => {
                                                                setStartIndex(0)
                                                                navigate(`/teammember/${slug}?tab=podcast`)
                                                                setPodcastType('podcast')
                                                            }}>Podcast</Button>
                                                }
                                                {showPerspectivesButton &&
                                                <Button isActive={(selectedTab == 'perspectives' || podcastType === 'perspectives')}
                                                        onClick={() => {
                                                            navigate(`/teammember/${slug}?tab=perspectives`)
                                                            setPodcastType('perspectives')
                                                        }}>Perspectives</Button>
                                                }
                                            </Box>
                                            <All hasNewsData={hasNewsData} podcastType={selectedTab || podcastType} startIndex={startIndex}
                                                 setStartIndex={setStartIndex} pageCount={pageCount}
                                                 podcastsRef={podcastsRef} podcastCount={podcastCount}/>
                                        </Box>

                                        <Box
                                            alignSelf={'stretch'}
                                            marginLeft={{base: 'none', md: 'auto !important'}}
                                            width={{base: 'full', md: '410px'}}
                                            height={'100%'}
                                        >
                                            <News setHasNewsData={setHasNewsData}/>
                                        </Box>
                                    </>
                                }
                            </Stack>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};
export default Podcasts;
